import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "./firebase";

function Login({ setToken, setIsLoggedOut }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState('');
  const [isConfirmPasswordVisible, setIsConfirmPasswordVisible] = useState(false);
  const navigate = useNavigate(); // Use navigate to redirect

  const handleLogin = async () => {
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);

      // Get Firebase token
      const token = await userCredential.user.getIdToken();
      const refreshToken = userCredential.user.refreshToken;
      const userId = userCredential.user.uid;
      const firstName = userCredential.user.displayName || "User";
      const emailName = userCredential.user.email;

      // Store the token in state and localStorage
      setToken(token);

      localStorage.setItem('token', token);
      localStorage.setItem('refreshToken', refreshToken);
      localStorage.setItem('userId', userId);
      localStorage.setItem('firstName', firstName);
      localStorage.setItem('email', emailName);
      
      // Redirect to dashboard after successful login
      window.location.href = "/dashboard";
    } catch (error) {
      setError('Login failed. Please check your credentials.');
      console.error("Error during login:", error);
    }
  };

  const eyeIcons = {
    open: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ width: "20px", height: "20px" }}
      >
        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
        <circle cx="12" cy="12" r="3" fill="#666" />
      </svg>
    ),
    closed: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ width: "20px", height: "20px" }}
      >
        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
        <circle cx="12" cy="12" r="3" fill="#666" />
        <line x1="4" y1="4" x2="20" y2="20" />
      </svg>
    ),
  };

  return (
    <div style={styles.container}>
      {/* Logo */}
      <img
        src="/proactr_logo_dark.png"
        alt="ProACTr Logo"
        style={styles.logo}
      />

      {/* Title and Subtitle */}
      <h1 style={styles.title}>Leadership Conversation Simulator</h1>
      <h2 style={styles.subtitle}>Learn by Doing</h2>

      {/* Login form */}
    <div style={styles.formContainer}>
      <h1 style={styles.title}>Login</h1>
      <div style={{ width: '300px', marginTop: '5px' }}>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email"
          style={styles.input}
        />
      </div>
      <div style={{ position: 'relative', width: '300px' }}>
        <input
          type={isConfirmPasswordVisible ? "text" : "password"}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
          style={styles.input}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              handleLogin(); // Call handleLogin when Enter is pressed
            }
          }}
        />
        <span
          onClick={() => setIsConfirmPasswordVisible(!isConfirmPasswordVisible)}
          style={styles.eyeIcon}
        >
          {isConfirmPasswordVisible ? eyeIcons.open : eyeIcons.closed}
        </span>
      </div>
      <button onClick={handleLogin} style={styles.button}>
        Login
      </button>

      {/* Forgot Password Link */}
      <p style={styles.forgotPassword}>
        Did you forget your password?{' '}
        <a href="/forgot-password" style={styles.link}>
          Click here
        </a>
      </p>

      {error && <p style={styles.error}>{error}</p>}

    </div>
    </div>
  );
}

// CSS in JS styles
const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    //justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    fontFamily: '"Open Sans", Arial, sans-serif',
    backgroundColor: '#f9f9f9',
    position: 'relative',
    marginTop: '-70px',
  },
  logo: {
    width: '500px',
    marginTop: '100px', // Set distance from the top of the page for the logo
  },
  title: {
    fontSize: '30px',
    fontWeight: 'bold',
    color: '#333',
    marginTop: '20px', // Set space below the logo
  },
  subtitle: {
    fontSize: '25px',
    fontStyle: 'italic',
    color: '#666',
    marginTop: '0px', // Set space below the title
  },
  formContainer: {
    width: '300px',
    textAlign: 'center',
    marginTop: '10px', // Set space below the subtitle for the form
  },
  loginTitle: {
    fontSize: '24px',
    marginTop: '10px',
    color: '#333',
  },
  input: {
    width: '275px',
    padding: '10px',
    marginTop: '5px',
    fontSize: '16px',
    borderRadius: '5px',
    border: '1px solid #ccc',
  },
  button: {
    width: '70%',
    padding: '10px',
    backgroundColor: '#704ea0',
    color: '#fff',
    fontSize: '18px',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    marginTop: '10px',
  },
  error: {
    color: 'red',
    marginTop: '20px',
  },
  registerText: {
    marginTop: '15px',
    fontSize: '14px',
  },
  forgotPassword: {
    marginTop: '15px',
    fontSize: '14px',
    textAlign: 'center',
    color: '#333',
  },
  link: {
    color: '#704ea0',
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  eyeIcon: {
    position: "absolute", // Position the icon inside the input
    right: "20px", // Place it near the right edge
    transform: "translateY(18px)",
    cursor: "pointer",
    fontSize: "16px",
    color: "rgba(0, 0, 0, 0.6)", // Black icon for simplicity
  },
};


export default Login;
